import * as React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import Sitemark from './SitemarkIcon';
import ColorModeIconDropdown from '../customizations/ColorModeIconDropdown';
import   {useMediaQuery,useTheme} from '@mui/material';
import {StyledToolbar, SilverButton, ActiveSilverButton} from '../utils/constants';
// ✅ 引入 API
import { checkAuthStatus } from '../utils/api';
import HotTopicsModal from './HotTopicsModal';
import useShowHotTopics from '../hooks/useShowHotTopics';

export default function AppAppBar({ onSearch }) {
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const [query, setQuery] = React.useState('');
  const [isAuthenticated, setIsAuthenticated] = React.useState(checkAuthStatus());
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const showHot = useShowHotTopics();                     // 新增
  const [hotOpen, setHotOpen] = React.useState(false);    // 新增

  // ✅ waroom 手機端隱藏 AppAppBar
  if (isMobile && location.pathname === '/waroom') {
    return null;
  }

  const handleInputChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^\u4e00-\u9fa5_a-zA-Z0-9 ]/g, '');
    value = value.replace(/ {3,}/g, '  ');
    if (value.length > 20) {
      value = value.slice(0, 20);
    }
    setQuery(value);
  };

  const handleSearch = () => {
    const trimmed = query.trim();
    if (!trimmed) return;
    onSearch(trimmed);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <AppBar
      position="fixed"
      enableColorOnDark
      sx={{
        boxShadow: 0,
        bgcolor: 'transparent',
        backgroundImage: 'none',
        mt: 'calc(var(--template-frame-height, 0px) + 28px)',
      }}
    >
      <Container maxWidth="lg">
        {/* 主 Toolbar */}
        <StyledToolbar variant="dense" disableGutters>
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 0 }}>
            <Sitemark />

            {/* 桌面端導航按鈕 */}
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              <Link to="/news">
                {location.pathname === '/news' ? <ActiveSilverButton>財經新聞</ActiveSilverButton> : <SilverButton>財經新聞</SilverButton>}
              </Link>
              <Link to="/chart">
                {location.pathname === '/chart' ? <ActiveSilverButton>金融圖表</ActiveSilverButton> : <SilverButton>金融圖表</SilverButton>}
              </Link>
              <Link to="/waroom">
                {location.pathname === '/waroom' ? <ActiveSilverButton>政經戰情室</ActiveSilverButton> : <SilverButton>政經戰情室</SilverButton>}
              </Link>
              <Link to="/institute">
                {location.pathname === '/institute' ? <ActiveSilverButton>無政府主義研究院</ActiveSilverButton> : <SilverButton>無政府主義研究院</SilverButton>}
              </Link>
              <Link to="/declaration">
                {location.pathname === '/declaration' ? <ActiveSilverButton>聲明</ActiveSilverButton> : <SilverButton>聲明</SilverButton>}
              </Link>
            </Box>
          </Box>

          {/* 桌面端右側按鈕 */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1, alignItems: 'center' }}>
            {isAuthenticated ? (
              <Link to="/dashboard"><Button color="primary" variant="text">個人中心</Button></Link>
            ) : (
              <>
                <Link to="/signin"><Button color="primary" variant="text">登入</Button></Link>
                <Link to="/signup"><Button color="primary" variant="contained">註冊</Button></Link>
              </>
            )}
            <ColorModeIconDropdown />
          </Box>

          {/* 手機端 */}
          <Box sx={{ display: { xs: 'flex', md: 'none' }, gap: 1 }}>
            <ColorModeIconDropdown size="medium" />
            <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="top"
              open={open}
              onClose={toggleDrawer(false)}
              PaperProps={{ sx: { top: 'var(--template-frame-height, 0px)' } }}
            >
              <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <IconButton onClick={toggleDrawer(false)}><CloseRoundedIcon /></IconButton>
                </Box>

                {/* 手機端導航 */}
                <Link to="/news">{location.pathname === '/news' ? <ActiveSilverButton>財經新聞</ActiveSilverButton> : <SilverButton>財經新聞</SilverButton>}</Link>
                <Link to="/chart">{location.pathname === '/chart' ? <ActiveSilverButton>金融圖表</ActiveSilverButton> : <SilverButton>金融圖表</SilverButton>}</Link>
                <Link to="/waroom">{location.pathname === '/waroom' ? <ActiveSilverButton>政經戰情室</ActiveSilverButton> : <SilverButton>政經戰情室</SilverButton>}</Link>
                <Link to="/institute">{location.pathname === '/institute' ? <ActiveSilverButton>無政府主義研究院</ActiveSilverButton> : <SilverButton>無政府主義研究院</SilverButton>}</Link>
                <Link to="/declaration">{location.pathname === '/declaration' ? <ActiveSilverButton>聲明</ActiveSilverButton> : <SilverButton>聲明</SilverButton>}</Link>
                
                <Divider sx={{ my: 3 }} />

                {/* 今日熱點（左）與個人中心（最右）並列 */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {showHot && (
                    <Button
                      color="primary"
                      variant="text"
                      onClick={() => {
                        setOpen(false);
                        setHotOpen(true);
                      }}
                    >
                      🔥 今日熱點
                    </Button>
                  )}
                  {isAuthenticated && (
                    <Link to="/dashboard" style={{ marginLeft: 'auto' }}>
                      <Button color="primary" variant="text">個人中心</Button>
                    </Link>
                  )}
                </Box>

                {/* 未登入時，註冊、登入維持原本的獨立一行 */}
                {!isAuthenticated && (
                  <>
                    <MenuItem><Link to="/signup"><Button color="primary" variant="contained" fullWidth>註冊</Button></Link></MenuItem>
                    <MenuItem><Link to="/signin"><Button color="primary" variant="outlined" fullWidth>登入</Button></Link></MenuItem>
                  </>
                )}
              </Box>
            </Drawer>
          </Box>
        </StyledToolbar>

        {/* 新聞頁搜索框 */}
        {(location.pathname === '/news' || location.pathname === '/') && (
          <Box
            sx={{
              // ✅ 1. 將 xs 改為 'flex'，讓手機版也顯示
              display: 'flex', 
              width: '100%',
              // ✅ 2. 稍微調整對齊，手機置中，桌機靠左
              justifyContent: { xs: 'center', md: 'flex-start' }, 
              // ✅ 3. 微調左右 padding，讓手機版不會太貼邊
              px: { xs: 2, md: 3 }, 
              py: 1,
              mt: -0.5,
              backgroundColor: 'rgba(255,255,255,0.05)',
              borderRadius: 1,
            }}
          >
            <TextField
              size="small"
              placeholder="搜索新聞..."
              value={query}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              // ✅ 4. 讓輸入框在手機上稍微拉寬一點，視覺更平衡
              fullWidth={isMobile} 
              InputProps={{
                startAdornment: <SearchIcon sx={{ color: 'gray', mr: 1 }} />,
                sx: {
                  backgroundColor: 'rgba(255,255,255,0.9)',
                  borderRadius: '999px',
                  px: 1.5,
                  py: 0.5,
                  fontSize: '0.85rem',
                  transition: 'all 0.2s ease',
                  '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.1)' },
                  '&.Mui-focused': { boxShadow: '0 0 0 2px rgba(25,118,210,0.25)' },
                },
              }}
              sx={{ minWidth: { xs: '100%', md: 300 } }} // 手機版滿版，桌機版固定寬度
            />
          </Box>
        )}
      </Container>
      <HotTopicsModal open={hotOpen} onClose={() => setHotOpen(false)} />
    </AppBar>
  );
}
